import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '@app-core/services/data/data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-coaching-config-help',
  templateUrl: './coaching-config-help.component.html',
  styleUrls: ['./coaching-config-help.component.scss'],
})
export class CoachingConfigHelpComponent implements OnInit, OnDestroy {
  public currentLanguage: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.dataService._currentLanguage.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      this.currentLanguage = value;
      this.currentLanguage = 'en'; // hardcoding to english as of now since the images are only in english. Once we have images in other languages, we can remove this line and show images based on selected language;
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
